import { ProfileType } from 'modules/domain/user/types'
import { urlMaker } from 'modules/utils/urlMaker'

export const companiesEndpoints = {
  company: urlMaker('/companies/'),
  companyDadata: () => '/companies/suggest/',
  companyBranches: (companyId: string) => `/companies/${companyId}/descendants/?include-self=true`,
  companyComments: (companyId: string) => `/companies/${companyId}/comments/`,
  employee: (companyId: string) => `/companies/${companyId}/employees/`,
  activeEmployees: (companyId: string) => `/companies/${companyId}/employees/?is_active=true`,
  activeEmployeesByTypes: (companyId: string, profileType: ProfileType[]) => {
    const profileTypeQuery = profileType.map((type) => `profile_type=${type}`).join('&')
    return `/companies/${companyId}/employees/?is_active=true&${profileTypeQuery}`
  },
  companyExtraData: (companyId: string, id?: string) => `/companies/${companyId}/extra-data/${id ? `${id}/` : ''}`,
  companyContracts: (id: string) => `/companies/${id}/contracts/`,
  companyContacts: (id: string) => `/companies/${id}/contacts/`,
  contractFiles: (companyId: string, contractId: string) => `/companies/${companyId}/contracts/${contractId}/files/`,
  deleteContractFile: (companyId: string, contractId: string, fileId: string) =>
    `/companies/${companyId}/contracts/${contractId}/files/${fileId}/`,
  companyAddress: (companyId: string, userId?: string) =>
    `/companies/${companyId}/addresses/${userId ? `?owner_id=${userId}` : ''}`,
  companyAddressDetails: (companyId: string, addressId: string) => `/companies/${companyId}/addresses/${addressId}/`,
  companyProductData: (companyId: string, id?: string) => `/companies/${companyId}/product-data/${id ? `${id}/` : ''}`,
  companyActs: (companyId: string) => `companies/${companyId}/reconciliation-acts/`,
  companyAct1C: (companyId: string) => `companies/${companyId}/reconciliation-acts/request-upload/`,
  removeAct: (companyId: string, fileId: string) => `companies/${companyId}/reconciliation-acts/${fileId}/`,
  removeAllActs: (companyId: string) => `companies/${companyId}/reconciliation-acts/delete-all-acts/`,
  requestFactoring: (companyId: string) => `/companies/${companyId}/factoring/`,
  changeFactoringStatus: (companyId: string, factoringId?: string) =>
    `/companies/${companyId}/factoring/${factoringId}/change_status/`,
  keyCompany: (companyId: string) => `/companies/${companyId}/mark-significant/`,
  downloadMarkTable: () => '/companies/market-zones/export-with-marks/',
  productDataAnalytics: () => '/companies/product-data-analytics/',
  productDataAnalyticsSum: () => '/companies/product-data-analytics/aggregates/',
  productDataAnalyticsStats: () => '/companies/product-data-analytics/rosstat-numbers/',
  makeGroupParent: (companyId: string) => `/companies/${companyId}/make-group-parent/`,
  companyGroupContacts: (companyId: string) => `/companies/${companyId}/group-contacts/`,
}
